import { ONBOARDING_STEP, UserRole } from './user'

export type ProtectedRoute =
  | typeof ROUTES.PROJECTS
  | typeof ROUTES.LANDSCAPES
  | typeof ROUTES.ATLAS
  | typeof ROUTES.TEAM
  | typeof ROUTES.PROJECT_DETAILS
  | typeof ROUTES.LANDSCAPES_PROJECT_DETAILS

export const ROUTES = {
  // Public routes
  HOME: '/',
  SIGN_IN: '/auth/sign-in',
  SIGN_UP: '/auth/sign-up',
  FORGOT_PASSWORD: '/auth/forgot-password',
  FORGOT_PASSWORD_SENT: '/auth/forgot-password-sent',
  SET_NEW_PASSWORD: '/auth/set-new-password',
  PERSONAL_INFO: '/auth/personal-info',
  REQUEST_SENT: '/auth/request-sent',
  ONBOARDING_WELCOME: '/auth/onboarding/welcome',
  ONBOARDING_PERSONALIZE: '/auth/onboarding/personalize',
  ONBOARDING_INTERESTS: '/auth/onboarding/interests',
  ONBOARDING_MEET_COPA: '/auth/onboarding/meetcopa',

  // Protected routes
  DASHBOARD: '/dashboard',
  HOME_ALT: '/dashboard/home',
  ONBOARDING: '/dashboard/onboarding',
  SUBS: '/dashboard/subs',
  PROJECTS: '/dashboard/projects',
  PROJECT_DETAILS: '/dashboard/project/:id',
  LANDSCAPES: '/dashboard/landscapes', // public projects route
  LANDSCAPES_PROJECT_DETAILS: '/dashboard/landscapes/project/:id', // same as PROJECT_DETAILS, use diff name for active tab highlight
  ATLAS: '/dashboard/atlas',
  PROFILE: '/dashboard/profile',
  TEAM: '/dashboard/team',
  SUPER_ADMIN: '/dashboard/superadmin',
  LAB: '/dashboard/lab',
  LOGOUT: '/auth/logout',
  LEGAL: '/legal',
  OAUTH_INTERACTION: '/oauth/interaction/:uid',
  LEARN: '/dashboard/learn',
  DMRV: '/dashboard/dmrv',
  SRM: '/dashboard/srm',
} as const

export const STEP_ROUTES: Record<ONBOARDING_STEP, string> = {
  [ONBOARDING_STEP.ONBOARDING_WELCOME]: ROUTES.ONBOARDING_WELCOME,
  [ONBOARDING_STEP.ONBOARDING_PERSONALIZE]: ROUTES.ONBOARDING_PERSONALIZE,
  [ONBOARDING_STEP.ONBOARDING_INTERESTS]: ROUTES.ONBOARDING_INTERESTS,
  [ONBOARDING_STEP.ONBOARDING_COPA]: ROUTES.ONBOARDING_MEET_COPA,
  [ONBOARDING_STEP.ONBOARDING_DONE]: ROUTES.PROJECTS,
}

export const ROLE_PERMISSIONS: Record<UserRole, string[]> = {
  ADMIN: [
    ROUTES.PROJECTS,
    ROUTES.PROJECT_DETAILS,
    ROUTES.ATLAS,
    ROUTES.HOME_ALT,
    ROUTES.SUPER_ADMIN,
    ROUTES.TEAM,
    ROUTES.SUBS,
    ROUTES.LOGOUT,
    ROUTES.PROFILE,
    ROUTES.LEGAL,
    ROUTES.LEARN,
    ROUTES.DMRV,
    ROUTES.SRM,
    ROUTES.LANDSCAPES,
    ROUTES.LANDSCAPES_PROJECT_DETAILS,
  ],
  CONTRIBUTOR: [
    ROUTES.PROJECTS,
    ROUTES.SUPER_ADMIN,
    ROUTES.HOME_ALT,
    ROUTES.PROJECT_DETAILS,
    ROUTES.ATLAS,
    ROUTES.LOGOUT,
    ROUTES.PROFILE,
    ROUTES.LEGAL,
    ROUTES.LEARN,
    ROUTES.DMRV,
    ROUTES.SRM,
    ROUTES.LANDSCAPES,
    ROUTES.LANDSCAPES_PROJECT_DETAILS,
  ],
  VIEWER: [
    ROUTES.PROJECTS,
    ROUTES.SUPER_ADMIN,
    ROUTES.HOME_ALT,
    ROUTES.PROJECT_DETAILS,
    ROUTES.SUPER_ADMIN,
    ROUTES.LOGOUT,
    ROUTES.ATLAS,
    ROUTES.PROFILE,
    ROUTES.LEGAL,
    ROUTES.LEARN,
    ROUTES.DMRV,
    ROUTES.SRM,
    ROUTES.LANDSCAPES,
    ROUTES.LANDSCAPES_PROJECT_DETAILS,
  ],
}
